var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2694 19.0702V5.17869C20.2694 4.44184 19.9767 3.73517 19.4556 3.21413C18.9346 2.6931 18.2279 2.40039 17.4911 2.40039H6.3779C5.64105 2.40039 4.93438 2.6931 4.41335 3.21413C3.89232 3.73517 3.59961 4.44184 3.59961 5.17869V19.0702C3.59961 19.807 3.89232 20.5137 4.41335 21.0347C4.93438 21.5557 5.64105 21.8485 6.3779 21.8485H17.4911C18.2279 21.8485 18.9346 21.5557 19.4556 21.0347C19.9767 20.5137 20.2694 19.807 20.2694 19.0702Z",
    stroke: "#343440",
    strokeWidth: 1.70171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76758 9.34619H14.7133M7.76758 12.1245H16.1025M7.76758 14.9028H11.935",
    stroke: "#343440",
    strokeWidth: 1.70171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDocument);
export default __webpack_public_path__ + "static/media/start-document.e8b6312d40ed60d14669b07a5a2bce1a.svg";
export { ForwardRef as ReactComponent };